const styles = theme => ({
  loading: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%'
  }
});

export default styles;